import { render, staticRenderFns } from "./CancelLoan.vue?vue&type=template&id=30b2067e&"
import script from "./CancelLoan.vue?vue&type=script&lang=js&"
export * from "./CancelLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports